import React from 'react';
import striptags from 'striptags';
import {
  getBreakSpaceIndex,
  htmlToCharacterCheck,
} from '@services/string-transformation-services';
import { safeCurrentLanguage } from '@services/drupal-services';
import Translate from '@components/translation/translate-text-wrapper';

/**
 * Get Teaser Text.
 */
const getTeaserText = (
  summary: string | undefined,
  body: string,
  teaserLength: number
): string => {
  const teaserText =
    summary && summary.length > 0
      ? striptags(summary).trim()
      : striptags(body).trim();
  const breakSpaceIndex = getBreakSpaceIndex(teaserText, teaserLength);
  if (teaserText.length > teaserLength && breakSpaceIndex !== null) {
    return `${teaserText.slice(0, teaserLength + breakSpaceIndex)} ...`;
  }
  return teaserText;
};

/**
 * Article.
 */
const Article: React.FC<{
  title: string;
  releaseDate: string;
  url: string;
  imageId: string;
  body: string;
  summary?: string;
  featured: boolean;
  category: string;
  blogCategory: string;
}> = ({
  title,
  releaseDate,
  url,
  imageId,
  body,
  summary,
  featured,
  category,
  blogCategory,
}) => {
  let teaserLength = safeCurrentLanguage() !== 'zh-hans' ? 240 : 50;
  teaserLength =
    safeCurrentLanguage() === 'ja' && category === 'press-release'
      ? 50
      : teaserLength;
  const teaser = getTeaserText(summary, body, teaserLength);

  /**
   * Render.
   */
  return (
    <article
      className={`${
        featured
          ? 'newsroom-entry-vertical large-vertical-margin-bottom medium-vertical-margin-top'
          : 'medium-vertical-margin'
      }
        ${!featured && imageId ? 'grid-1-2-columns' : ''}`}>
      {/* Blog Image */}
      {imageId && (
        <div className="image-container">
          <img
            className={`lazy ${
              featured ? 'rounded-corners' : 'small-rounded-corners'
            }`}
            data-src={`https://varian.widen.net/content/${imageId}/webp/?app=portals&w=${
              featured ? '900' : '480'
            }&h=${featured ? '506' : '480'}&crop=true`}
            alt={title}
          />
        </div>
      )}

      <div className="news-articles-info">
        {category === 'blogs' && blogCategory && blogCategory !== '' && (
          <div className="blog-category">
            <span>{blogCategory}</span>
          </div>
        )}
        <h3>{htmlToCharacterCheck(title)}</h3>
        <time className="news-item-date" dateTime={releaseDate}>
          {releaseDate}
        </time>
        {teaser !== '' && teaser !== '&nbsp;' && (
          <p className="summary">{teaser}</p>
        )}
        <div className="link-container">
          <a href={url} className="featured-link">
            <Translate>Read more</Translate>
          </a>
        </div>
      </div>
    </article>
  );
};
export default Article;
